const COMMENTS = [
  { id: 1, name: '吃瓜路人甲', time: '2 小时前', avatar: '甲', content: '这个黑料视频网站太全了！我一直在找的八卦资源这里都有，在线观看超流畅，画质也清晰，已经推荐给身边所有爱吃瓜的朋友了。官网地址收藏了！', likes: 1283 },
  { id: 2, name: '娱乐圈观察员', time: '5 小时前', avatar: '观', content: '作为资深吃瓜群众，这个黑料视频平台确实做得很专业。更新速度快，分类清晰，手机app下载也很方便，每天都要刷一刷看看有没有新料。', likes: 967 },
  { id: 3, name: '深夜不关机', time: '8 小时前', avatar: '夜', content: '找了很久的黑料视频下载入口终于在这里找到了！资源丰富，各种热门黑料一应俱全，下载速度也很快。这个最新地址大家赶紧收藏，免得下次找不到。', likes: 2341 },
  { id: 4, name: '真相挖掘机', time: '12 小时前', avatar: '真', content: '黑料视频在线观看体验非常好，没有广告骚扰，页面简洁。内容覆盖范围广，从娱乐圈到网红圈应有尽有，每天更新200+新内容，吃瓜吃到撑！', likes: 756 },
  { id: 5, name: '八卦小能手', time: '1 天前', avatar: '八', content: '这个平台的黑料视频质量是真的高！不是那种标题党，内容都有实锤。手机app也做得很好用，下载安装简单，随时随地都能看最新黑料，强烈推荐！', likes: 1892 },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">网友热议</h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">来看看大家对黑料视频的真实评价，百万用户的选择不会错</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {COMMENTS.map((comment) => (
            <div key={comment.id} className="bg-background-100 border border-background-200/70 rounded-xl p-5 flex flex-col">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary-600">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground-900 truncate">{comment.name}</p>
                  <p className="text-xs text-foreground-500">{comment.time}</p>
                </div>
                <div className="flex items-center gap-0.5 text-accent-500 flex-shrink-0">
                  <i className="ri-star-fill text-xs"></i>
                  <i className="ri-star-fill text-xs"></i>
                  <i className="ri-star-fill text-xs"></i>
                  <i className="ri-star-fill text-xs"></i>
                  <i className="ri-star-fill text-xs"></i>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1">{comment.content}</p>
              <div className="flex items-center gap-4 mt-4 pt-3 border-t border-background-200/60">
                <button className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes.toLocaleString()}</span>
                </button>
                <button className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-chat-1-line"></i>
                  <span>回复</span>
                </button>
                <button className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer ml-auto">
                  <i className="ri-share-forward-line"></i>
                  <span>分享</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}